import React from 'react'
import { useTranslation } from 'next-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import styles from './TrophyPrivateMemoryCard.module.scss'

export const TrophyPrivateMemoryCard: React.FC = () => {
  const { t } = useTranslation('trophy_memories')

  return (
    <section className={ styles.trophyPrivateMemoryCard__container }>
      <div className={ styles.trophyPrivateMemoryCard__imageWrapper }>
        <FontAwesomeIcon
          icon={ faEyeSlash }
          size="2x"
          className={ styles.trophyPrivateMemoryCard__image }
        />
      </div>

      <div className={ styles.trophyPrivateMemoryCard__data }>
        <p className={ styles.trophyPrivateMemoryCard__title }>
          { t('private_card_title') }
        </p>

        <p className={ styles.trophyPrivateMemoryCard__date }>
        { t('private_card_description') }
        </p>
      </div>
    </section>
  )
}
